import platform from 'platform';

export const isIosDevice = () => (platform.product === 'iPad' || platform.product === 'iPhone');
export const isMobileDevice = () => (platform.os.family === 'Android' || platform.os.family === 'iOS' || platform.os.family === 'Windows Phone');
export const isWebkit = () => (platform.layout === 'WebKit');
